/**
 * Spec 035 v0.4, step 4: a unit's events — what it announced and what it got from the units it
 * listens to — and its subscriptions both ways. Heads subscribe their units; people read.
 */

import { useQuery } from "@tanstack/react-query";

import { UnitEvents } from "@/api/units";
import { formatRelativePast } from "@/lib/format";
import { listenerLine, listensLine } from "@/lib/units";

export function UnitEventsBlock({ unitId }: { unitId: string }) {
  const feed = useQuery({ queryKey: ["departments", "events", unitId], queryFn: () => UnitEvents.feed(unitId) });
  const subs = useQuery({ queryKey: ["departments", "subscriptions", unitId], queryFn: () => UnitEvents.subscriptions(unitId) });
  const events = feed.data ?? [];
  const listens = subs.data?.listens ?? [];
  const listeners = subs.data?.listeners ?? [];
  if (!events.length && !listens.length && !listeners.length) {
    return <p className="text-meta text-p-text-muted">Событий и подписок нет: руководитель подписывает подразделение сам.</p>;
  }
  return (
    <div className="flex flex-col gap-2">
      {(listens.length > 0 || listeners.length > 0) && (
        <div className="flex flex-col gap-1 text-meta text-p-text-muted">
          {listens.map((s) => <span key={s.id}>Слушает — {listensLine(s)}</span>)}
          {listeners.map((s) => <span key={s.id}>{listenerLine(s)}</span>)}
        </div>
      )}
      {events.length > 0 && (
        <ul className="overflow-hidden rounded-card border border-p-border bg-p-surface">
          {events.slice(0, 20).map((e) => (
            <li key={e.id} className="flex flex-col gap-0.5 border-b border-p-border px-4 py-2.5 last:border-0">
              <span className="text-[15px] font-semibold leading-5 text-p-text">{e.title}</span>
              <span className="text-meta text-p-text-muted">
                {e.unit_id === unitId ? "объявило" : `от «${e.unit_name}»`} · {e.kind}
                {e.order_number && ` · №${e.order_number}`} · {formatRelativePast(new Date(e.created_at))}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}